import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import ProtectedFile from './ProtectedFile.jsx';

const CategoryInfo = ({ currentGroup, setCurrentGroupInfoOpen }) => {
	const cardRef = useRef(null);
	const [bgImage, setBgImage] = useState(null);

	useEffect(() => {
		if (!currentGroup) return;
		if (!currentGroup.mediaItems?.length) return;
		setBgImage(currentGroup.mediaItems.find(el => el.isImage))
	}, [currentGroup]);

	useEffect(() => {
		if (!cardRef.current) return
		gsap.fromTo(cardRef.current,
			{ scale: 0, opacity: 0 },
			{ scale: 1, opacity: 1, duration: 0.5 }
		)
	}, [cardRef])

	const animateCard = (ev) => {
		ev.preventDefault();

		setCurrentGroupInfoOpen(false)

		//gsap.to(cardRef.current, { x: 0, y: 0, rotation: (360 * 4), scale: 0, opacity: 0, duration: 0.8 })

		//setTimeout(() => {
		//setCurrentGroupInfoOpen(false)
		//}, 800)
	}

	return (
		<div className="d-lg-flex flex-wrap category-info w-100 position-relative" ref={cardRef}>
			<div className="logo-oleario">
				<img src="/img/react-app/logo-oleario.png" />
			</div>

			{bgImage && (
				<div className="category-info-image">
					<ProtectedFile fileObj={bgImage} />
				</div>
			)}

			<div className={`bg-white position-relative p-3 p-lg-4 p-lg-5 pb-5 text-dark category-info-text ${!bgImage ? "w-100 mx-auto pt-12" : ""}`}>
				{/*<span className="badge rounded-pill text-white bg-danger fw-light fs-8 text-uppercase px-3">Tema</span>*/}
				{/*<h1 style={{ fontWeight: 700 }} className="fs-1 mb-3">{currentGroup.rootTitle}</h1>*/}

				{/*<span className="badge rounded-pill text-white bg-secondary fw-light fs-8 text-uppercase px-3">Argomento</span>*/}
				{/*<h2 className="fw-bold fs-2">{currentGroup.title}</h2>*/}

				<h1 style={{ fontWeight: 700 }} className={`fs-1 mb-3 ${!bgImage ? "mt-5" : "mt-3"} text-center`}>{currentGroup.title}</h1>

				{currentGroup.subTitle && (
					<h3 className="fw-semibold text-secondary group-subtitle fs-4 mt-n3 mb-3 text-center"><em>{currentGroup.subTitle}</em></h3>
				)}

				<div className="group-description fs-5 fw-light mt-0 mb-0" dangerouslySetInnerHTML={{ __html: currentGroup.description }}></div>

				<br clear="all" />


				{currentGroup.mediaItems?.length ? (
					<>
						<div className="d-none">
							<h2 className="fw-bold fs-3 text-uppercase mt-3 mb-2">Materiali utili</h2>

							{currentGroup.mediaItems?.map((el, index) => {
								return <ProtectedFile fileObj={el} key={index} download={true} className="list-item d-block py-2 fs-5 text-start border-bottom px-3">
									<span className="fw-semibold text-secondary d-flex justify-content-between">
										<span style={{ width: "99%", marginRight: "1rem" }}>
											{el.name}
											<div className="fw-light fs-6" dangerouslySetInnerHTML={{ __html: el.description }}></div>
										</span>
										<i className="bi bi-box-arrow-in-down-right fs-3"></i>
									</span>
								</ProtectedFile>
							})}
						</div>
					</>
				) : ""}


				<div className="text-center mt-3 mt-lg-5 w-100">
					<a href="#" className="btn btn-dark text-white btn-lg mx-auto px-5" onClick={(ev) => { animateCard(ev) }}>
						Continua
					</a>
				</div>
			</div>
		</div>
	);
};

export default CategoryInfo;
